export default "__VITE_ASSET__esm6DKiW__"